import { css } from "@emotion/react";

import { fontSize } from "~/client/styles/emotion/mixins/fontSize";

export const emptyCss = css({
  ...fontSize(14),
  margin: "12px 16px",
});
